import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const getPlanets = () => api.get("/planets").then((r) => r.data);
export const getPlanet = (id) => api.get(`/planets/${id}`).then((r) => r.data);
export const getMateria = (q) => api.get("/materia-medica", { params: q ? { q } : {} }).then((r) => r.data);
export const getCases = () => api.get("/case-studies").then((r) => r.data);
export const getTestimonials = () => api.get("/testimonials").then((r) => r.data);
export const getBlog = () => api.get("/blog").then((r) => r.data);

export const createConsultation = (data) => api.post("/consultations", data).then((r) => r.data);
export const createContact = (data) => api.post("/contact", data).then((r) => r.data);
export const subscribeNewsletter = (email) => api.post("/newsletter", { email }).then((r) => r.data);
export const aiRemedySuggest = (data) => api.post("/ai/remedy-suggest", data).then((r) => r.data);
export const aiMateriaSearch = (query) => api.post("/ai/materia-search", { query }).then((r) => r.data);
